// ============================================
// APPLICATION - Descargas Hooks
// ============================================

import { useMutation } from '@tanstack/react-query';
import { descargasRepository } from '../../infrastructure/http/descargas.repository';

interface RegistrarDescargaParams {
  version: string;
  sistemaOperativo: 'windows' | 'mac' | 'linux';
}

/**
 * Hook para registrar una descarga de la aplicación de escritorio
 * Fire-and-forget: no bloquea la descarga si falla
 */
export const useRegistrarDescarga = () => {
  return useMutation({
    mutationFn: (params: RegistrarDescargaParams) => 
      descargasRepository.registrarDescarga(params),
    // No mostramos error al usuario - es tracking silencioso
    onError: (error) => {
      console.error('Error al registrar descarga:', error);
    },
  });
};
